<h1>Vos factures et avoirs</h1>

<fs-creancier-selector *ngIf="hasMultiSuppliers" [supplierList]="suppliersList" [selectedSupplierId]="activeSupplierId"
  (selectSupplier)="fournisseurChange($event)">
</fs-creancier-selector>


<div class="noinvoiceblock" *ngIf="rowsInitialized && suppliersList.length === 0">
  <div>
      <div class="icon" uiSvg source="assets/images/InfoQuitSaveHero"></div>
      <p class="bold">Vous n'avez pas encore de facture<p>
      <p>Vous recevrez une notification par e-mail dès qu'une facture sera disponible sur votre espace.</p>
  </div>
</div>
<div *ngIf="rowsInitialized && suppliersList.length > 0">
  <fs-filters pageName="bill-asset" (filterCriteriaChange)="filterPieces($event)"></fs-filters>
  <fs-cdk-table tableId="billAsset" data-testid="bill-asset-table" [rows]="accountResult.Pieces"
    [displayedColumns]="displayedColumns" [columns]="columns" [currentPage]="currentPage" [askedPage]="askedPage"
    [totalPages]="totalPages" [totalEntries]="totalEntries" [itemsPerPage]="itemsPerPage"
    [listSizeItemsPerPage]="listSizeItemsPerPage" (changePage)="changePage($event)"
    (callbackPagination)="fetchDocuments()" (changeSizePage)="onChangeSizePage($event)"
    (columnClicked)="onColumnClick($event)">
  </fs-cdk-table>
  <div *ngIf="accountResult.Pieces.length === 0" class="empty-infos">
    Aucune facture ou avoir trouvés
  </div>
</div>
